
import { useState } from 'react';
import Hero from './components/Hero';
import News from './components/News';
import Business from './components/Business';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Navbar from './components/Navbar';

export default function Home() {
  const [activeSection, setActiveSection] = useState('hero');

  return (
    <div className="bg-gradient-to-b from-gray-900 via-slate-900 to-black text-white">
      <Navbar activeSection={activeSection} setActiveSection={setActiveSection} />
      <Hero />
      <News />
      <Business />
      <Services />
      <Gallery />
      <Contact />
    </div>
  );
}
